import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { CfFileUploaderComponent } from '../../components/file-uploader/file-uploader.component';
export class CfFileUploaderService {
/**
 * Component described in CfFileUploaderComponent
 */
private uploader: CfFileUploaderComponent;
constructor() { }
/**
 * Function for opening browser window
 * @param {?} cfFileUploaderComponent  it is cfFileUploaderComponent object
 * @return {?}
 */
openLoadWindow(cfFileUploaderComponent: CfFileUploaderComponent) {
    this.uploader = cfFileUploaderComponent;
    this.uploader.loadWindowTrigger.nativeElement.click();
  }
/**
 * Function for sending files
 * @param {?} cfFileUploaderComponent  it is cfFileUploaderComponent object
 * @return {?}
 */
sendFiles(cfFileUploaderComponent: CfFileUploaderComponent) {
    this.uploader = cfFileUploaderComponent;
    this.uploader.properties.main.upload();
  }
/**
 * Function for clear files
 * @param {?} cfFileUploaderComponent  it is cfFileUploaderComponent object
 * @return {?}
 */
clear(cfFileUploaderComponent: CfFileUploaderComponent) {
    this.uploader = cfFileUploaderComponent;
    this.uploader.properties.main.remove();
  }
/**
 * Function for clear all files
 * @param {?} cfFileUploaderComponent  it is cfFileUploaderComponent object
 * @return {?}
 */
clearAll(cfFileUploaderComponent: CfFileUploaderComponent) {
    this.uploader = cfFileUploaderComponent;
    this.uploader.properties.main.queueObs.forEach(() => {
      setTimeout(() => {
        this.uploader.properties.main.remove();
      }, 0);
    })
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CfFileUploaderService_tsickle_Closure_declarations() {
/** @type {?} */
CfFileUploaderService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfFileUploaderService.ctorParameters;
/**
 * Component described in CfFileUploaderComponent
 * @type {?}
 */
CfFileUploaderService.prototype.uploader;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
